import React from 'react';
interface ProfileFieldProps {
  label: string;
  value: string;
  required?: boolean;
}
function ProfileField({
  label,
  value,
  required
}: ProfileFieldProps) {
  return <div className="px-4 py-3" data-sentry-component="ProfileField" data-sentry-source-file="profile-field.tsx">
      <label className="block text-sm font-normal text-gray-500">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <div className="mt-1">
        {label.toLowerCase() === 'mail' ? <a href={`mailto:${value}`} className="text-blue-600">
                {value}
              </a> : <span className="text-gray-900">{value}</span>}
      </div>
    </div>;
}
;
export default ProfileField;